/* ==========================================================================
   Maktar Shopify Theme — JavaScript
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initMobileMenu();
  initCart();
  initProductGallery();
  initVariantSelector();
  initQuantitySelector();
  initScrollAnimations();
  initAnnouncementBar();
  initProductTabs();
  initSmoothScroll();
  initCartSummaryBar();
});

/* ---------- Header Scroll ---------- */
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const onScroll = () => {
    header.classList.toggle('scrolled', window.scrollY > 20);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ---------- Mobile Menu ---------- */
function initMobileMenu() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const menu = document.querySelector('.mobile-menu');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const isOpen = menu.classList.toggle('open');
    toggle.classList.toggle('active', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      menu.classList.remove('open');
      toggle.classList.remove('active');
      document.body.style.overflow = '';
    });
  });
}

/* ---------- Cart System (Shopify Cart API) ---------- */

async function fetchCart() {
  const resp = await fetch('/cart.js');
  return resp.json();
}

async function addToCart(variantId, quantity, title) {
  const resp = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    console.error('Add to cart failed:', err);
    return;
  }
  const cart = await fetchCart();
  updateCartUI(cart);
  openCartDrawer();
  showAddedNotification(title || 'Item');
}

async function removeFromCart(lineKey) {
  const resp = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 })
  });
  const cart = await resp.json();
  updateCartUI(cart);
}

async function updateCartQuantity(lineKey, quantity) {
  if (quantity <= 0) { removeFromCart(lineKey); return; }
  const resp = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: quantity })
  });
  const cart = await resp.json();
  updateCartUI(cart);
}

function updateCartUI(cart) {
  const countElements = document.querySelectorAll('.cart-count');
  const totalItems = cart.item_count || 0;

  countElements.forEach(el => {
    el.textContent = totalItems;
    el.style.display = totalItems > 0 ? 'flex' : 'none';
  });

  renderCartDrawer(cart);
  updateCartSummaryBar(cart);
}

function renderCartDrawer(cart) {
  const itemsContainer = document.querySelector('.cart-drawer__items');
  const footer = document.querySelector('.cart-drawer__footer');
  if (!itemsContainer) return;

  const items = cart.items || [];

  if (items.length === 0) {
    itemsContainer.innerHTML = `
      <div class="cart-drawer__empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
        </svg>
        <p>Your cart is empty</p>
        <a href="/collections/all" class="btn btn--primary btn--sm" style="margin-top:1rem">Shop Now</a>
      </div>
    `;
    if (footer) footer.style.display = 'none';
    return;
  }

  if (footer) footer.style.display = 'block';

  itemsContainer.innerHTML = items.map(item => {
    const price = (item.final_line_price / 100).toFixed(2);
    const unitPrice = (item.final_price / 100).toFixed(2);
    const imgSrc = item.featured_image ? item.featured_image.url : item.image;
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    return `
    <div class="cart-item">
      <div class="cart-item__image">
        <img src="${imgSrc}" alt="${item.product_title}" loading="lazy">
      </div>
      <div class="cart-item__details">
        <div class="cart-item__title">${item.product_title}</div>
        ${variantTitle ? `<div class="cart-item__variant">${variantTitle}</div>` : ''}
        <div class="cart-item__price">$${price}</div>
        <div class="flex gap-sm" style="align-items:center;margin-top:0.5rem">
          <div class="quantity-selector" style="border-width:1px">
            <button onclick="updateCartQuantity('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
            <input type="text" value="${item.quantity}" readonly style="width:32px;font-size:0.8125rem">
            <button onclick="updateCartQuantity('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
          <span class="cart-item__remove" onclick="removeFromCart('${item.key}')">Remove</span>
        </div>
      </div>
    </div>`;
  }).join('');

  const subtotalEl = document.querySelector('.cart-drawer__subtotal-value');
  if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
}

function showAddedNotification(title) {
  const existing = document.querySelector('.cart-notification');
  if (existing) existing.remove();

  const notification = document.createElement('div');
  notification.className = 'cart-notification';
  notification.style.cssText = `
    position: fixed; bottom: 24px; right: 24px; z-index: 3000;
    background: var(--color-dark); color: white; padding: 1rem 1.5rem;
    border-radius: 12px; font-size: 0.9375rem; font-weight: 500;
    box-shadow: 0 12px 40px rgba(0,0,0,0.2);
    animation: fadeInUp 0.3s ease;
  `;
  notification.innerHTML = `<span style="color:var(--color-primary)">&#10003;</span> ${title} added to cart`;
  document.body.appendChild(notification);

  setTimeout(() => {
    notification.style.opacity = '0';
    notification.style.transform = 'translateY(10px)';
    notification.style.transition = 'all 0.3s ease';
    setTimeout(() => notification.remove(), 300);
  }, 2500);
}

function initCart() {
  /* Load cart from Shopify on page load */
  fetchCart().then(cart => updateCartUI(cart));

  document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
    btn.addEventListener('click', toggleCartDrawer);
  });

  const overlay = document.querySelector('.cart-overlay');
  if (overlay) {
    overlay.addEventListener('click', closeCartDrawer);
  }

  const closeBtn = document.querySelector('.cart-drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeCartDrawer);
  }

  /* Add-to-cart buttons now read data-variant-id for Shopify Cart API */
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      const title = btn.dataset.productTitle || 'Item';
      /* Read quantity from the nearest quantity selector, default 1 */
      const qtyInput = btn.closest('.product-info, .product-actions, section')
        ?.querySelector('.quantity-selector input');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (!variantId) {
        console.error('No variant ID found on add-to-cart button');
        return;
      }
      addToCart(Number(variantId), quantity, title);
    });
  });
}

function openCartDrawer() {
  document.querySelector('.cart-overlay')?.classList.add('open');
  document.querySelector('.cart-drawer')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  document.querySelector('.cart-overlay')?.classList.remove('open');
  document.querySelector('.cart-drawer')?.classList.remove('open');
  document.body.style.overflow = '';
}

function toggleCartDrawer() {
  const drawer = document.querySelector('.cart-drawer');
  if (drawer?.classList.contains('open')) {
    closeCartDrawer();
  } else {
    openCartDrawer();
  }
}

/* ---------- Product Gallery ---------- */
function initProductGallery() {
  const mainImage = document.querySelector('.product-gallery__main img');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  if (!mainImage || thumbs.length === 0) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const newSrc = thumb.querySelector('img')?.dataset.fullSrc || thumb.querySelector('img')?.src;
      mainImage.style.opacity = '0';
      mainImage.style.transition = 'opacity 0.2s ease';
      setTimeout(() => {
        mainImage.src = newSrc;
        mainImage.style.opacity = '1';
      }, 200);
    });
  });
}

/* ---------- Variant Selector ---------- */
function initVariantSelector() {
  /* Build variant map from <script type="application/json" id="variant-map"> if present */
  var variantMap = null;
  var mapEl = document.getElementById('variant-map');
  if (mapEl) {
    try { variantMap = JSON.parse(mapEl.textContent); } catch(e) { console.error('Bad variant map JSON', e); }
  }

  /* Build color-image map from <script type="application/json" id="color-image-map"> if present */
  var colorImageMap = null;
  var colorMapEl = document.getElementById('color-image-map');
  if (colorMapEl) {
    try { colorImageMap = JSON.parse(colorMapEl.textContent); } catch(e) { console.error('Bad color image map JSON', e); }
  }

  /* Resolve current selected options → variant from map */
  function resolveVariant() {
    if (!variantMap) return;
    var selected = {};
    document.querySelectorAll('.variant-options').forEach(function(c) {
      var active = c.querySelector('.variant-option.selected');
      if (active && active.dataset.option) {
        selected[active.dataset.option] = active.dataset.value;
      }
    });
    /* Find matching variant: all keys in variant.options must match selected */
    var match = variantMap.find(function(v) {
      return Object.keys(v.options).every(function(k) { return selected[k] === v.options[k]; });
    });
    if (!match) return;

    var addBtn = document.querySelector('[data-add-to-cart]');
    var priceEl = document.querySelector('.product-info__price .current-price');
    var btnPriceText = addBtn ? addBtn.childNodes : null;

    if (addBtn) {
      addBtn.dataset.variantId = match.id;
      addBtn.dataset.productPrice = match.price;
      /* Update button text: "Add to Cart — $XX.XX" */
      addBtn.innerHTML = 'Add to Cart &mdash; $' + match.price;
    }
    if (priceEl) {
      priceEl.textContent = '$' + match.price;
    }
    /* Update compare-at price if present */
    var compareEl = document.querySelector('.product-info__price .compare-price');
    if (compareEl && match.compare_price) {
      compareEl.textContent = '$' + match.compare_price;
      compareEl.style.display = '';
    } else if (compareEl) {
      compareEl.style.display = 'none';
    }

    /* Swap main product image based on selected variant options */
    if (colorImageMap) {
      /* Try compound key first (e.g. "White|USB-C"), then single Color key */
      var optKeys = Object.keys(selected).sort();
      var compoundKey = optKeys.map(function(k) { return selected[k]; }).join('|');
      var imgUrl = colorImageMap[compoundKey] || (selected['Color'] && colorImageMap[selected['Color']]) || null;
      if (imgUrl) {
        var mainImg = document.getElementById('product-main-image');
        if (mainImg) {
          mainImg.src = imgUrl;
          mainImg.alt = optKeys.map(function(k) { return selected[k]; }).join(' ');
        }
        var firstThumb = document.querySelector('.product-gallery__thumb:first-child img');
        if (firstThumb) {
          firstThumb.src = imgUrl;
          firstThumb.dataset.fullSrc = imgUrl;
        }
      }
    }
  }

  document.querySelectorAll('.variant-options').forEach(function(container) {
    container.querySelectorAll('.variant-option').forEach(function(option) {
      option.addEventListener('click', function() {
        container.querySelectorAll('.variant-option').forEach(function(o) { o.classList.remove('selected'); });
        option.classList.add('selected');

        if (variantMap) {
          resolveVariant();
        } else {
          /* Fallback for simple single-option products */
          var priceEl = document.querySelector('.product-info__price .current-price');
          if (priceEl && option.dataset.price) {
            priceEl.textContent = '$' + option.dataset.price;
          }
          if (option.dataset.variantId) {
            var addBtn = document.querySelector('[data-add-to-cart]');
            if (addBtn) addBtn.dataset.variantId = option.dataset.variantId;
          }
        }
      });
    });
  });

  /* Run once on load to set initial state from map */
  if (variantMap) resolveVariant();
}

/* ---------- Quantity Selector ---------- */
function initQuantitySelector() {
  document.querySelectorAll('.product-info .quantity-selector').forEach(selector => {
    const input = selector.querySelector('input');
    const minus = selector.querySelector('[data-action="minus"]');
    const plus = selector.querySelector('[data-action="plus"]');
    if (!input) return;

    minus?.addEventListener('click', () => {
      const val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });

    plus?.addEventListener('click', () => {
      const val = parseInt(input.value, 10);
      if (val < 99) input.value = val + 1;
    });
  });
}

/* ---------- Scroll Animations ---------- */
function initScrollAnimations() {
  const elements = document.querySelectorAll('.animate-on-scroll');
  if (elements.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, index * 100);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  elements.forEach(el => observer.observe(el));
}

/* ---------- Announcement Bar ---------- */
function initAnnouncementBar() {
  const closeBtn = document.querySelector('.announcement-bar__close');
  const bar = document.querySelector('.announcement-bar');
  if (!closeBtn || !bar) return;

  closeBtn.addEventListener('click', () => {
    bar.style.transform = 'translateY(-100%)';
    bar.style.transition = 'transform 0.3s ease';
    setTimeout(() => {
      bar.remove();
      document.documentElement.style.setProperty('--announcement-height', '0px');
    }, 300);
  });
}

/* ---------- Product Tabs ---------- */
function initProductTabs() {
  document.querySelectorAll('.product-tabs').forEach(tabContainer => {
    const buttons = tabContainer.querySelectorAll('.product-tabs__btn');
    const panels = tabContainer.querySelectorAll('.product-tabs__panel');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;

        buttons.forEach(b => b.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));

        btn.classList.add('active');
        tabContainer.querySelector(`[data-panel="${target}"]`)?.classList.add('active');
      });
    });
  });
}

/* ---------- Smooth Scroll ---------- */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}

/* ---------- Cart Summary Bar ---------- */
function initCartSummaryBar() {
  const bar = document.querySelector('.cart-summary-bar');
  if (!bar) return;

  bar.addEventListener('click', openCartDrawer);
  fetchCart().then(cart => updateCartSummaryBar(cart));
}

function updateCartSummaryBar(cart) {
  const bar = document.querySelector('.cart-summary-bar');
  if (!bar) return;

  /* Shopify cart object: item_count is total qty, total_price is in cents */
  const totalItems = cart.item_count || 0;
  const subtotal = (cart.total_price || 0) / 100;

  const badge = bar.querySelector('.cart-summary-bar__badge');
  const label = bar.querySelector('.cart-summary-bar__label');
  const total = bar.querySelector('.cart-summary-bar__total');

  if (badge) badge.textContent = totalItems;
  if (label) label.textContent = totalItems === 1 ? '1 item in cart' : totalItems + ' items in cart';
  if (total) total.textContent = '$' + subtotal.toFixed(2);

  bar.classList.toggle('has-items', totalItems > 0);
}
